module.exports = __webpack_public_path__ + "static/distribution3-3035053ed53209d3ca28cfa3713f5609.jpg";